import { gql } from 'graphql-request';

export const siteNatureRiskOverviewQuery = gql`
    query GetSiteNatureRiskOverview($organisationBusinessCentralId: String!, $siteId: ID!) {
        site(organisationBusinessCentralId: $organisationBusinessCentralId, siteId: $siteId) {
            id
            name
            portfolioRank {
                rank
                total
            }
            dependencyRank {
                rank
                total
            }
            impactRank {
                rank
                total
            }
            riskSummary {
                physicalNatureRisk
                operationalDependencies
                impactsOnNature
                stateOfNature
            }
            natureStatus {
                content
                createdAt
            }
            materialityBreakdown {
                name
                sourceKey
                materialityType
                score
            }
        }
    }
`;

export type SiteNatureRiskOverviewResult = {
    site: {
        id: string;
        name: string;
        portfolioRank: {
            rank: number;
            total: number;
        } | null;
        dependencyRank: {
            rank: number;
            total: number;
        } | null;
        impactRank: {
            rank: number;
            total: number;
        } | null;
        riskSummary: {
            physicalNatureRisk: number | null;
            operationalDependencies: number | null;
            impactsOnNature: number | null;
            stateOfNature: number | null;
        } | null;
        natureStatus: {
            content: string;
            createdAt: string;
        } | null;
        materialityBreakdown: {
            name: string;
            sourceKey: string;
            materialityType: 'Dependency' | 'Impact';
            score: number;
        }[];
    } | null;
};
